import { Icon } from '../PasswordValidation/PasswordValidation'
import { StyledContent, StyledTYP, StyledTitle } from './TYP.style'

const CircledCheckMarkIcon = () => {
  return (
    <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M39.9997 76.6663C60.2501 76.6663 76.6663 60.2501 76.6663 39.9997C76.6663 19.7492 60.2501 3.33301 39.9997 3.33301C19.7492 3.33301 3.33301 19.7492 3.33301 39.9997C3.33301 60.2501 19.7492 76.6663 39.9997 76.6663Z"
        strokeWidth="3.125"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.333 43.3333L38.333 50L51.6663 30"
        strokeWidth="3.125"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const TYP = ({ title, children }) => {
  return (
    <StyledTYP>
      <Icon Icon={CircledCheckMarkIcon} width="80px" stroke="#009FDA" />
      {title && <StyledTitle>{title}</StyledTitle>}
      <StyledContent>{children}</StyledContent>
    </StyledTYP>
  )
}
